module.exports = __webpack_public_path__ + "static/media/whatsApp.d0b48f1d.svg";